import { z } from 'zod';

export enum PowerUnit {
  W = 0,
  KW = 3,
  MW = 6,
  GW = 9,
  TW = 12,
}

export const PowerUnitSchema = z.nativeEnum(PowerUnit);
